module.exports = __webpack_public_path__ + "img/Führungskraftwagen.ed806c10.svg";